<template>
  <div class="q-mt-lg">
    <div
      class="row col-12 q-ml-lg justify-between items-center q-my-md text-brand-1 text-weight-medium"
      style="font-size: 16px"
    >
      <span>
        Fluxo de Aprovação - As pessoas precisam aprovar nessa sequência
      </span>

      <div>
        <q-btn
          @click="imprimir()"
          label="Imprimir"
          class="q-mr-sm"
          style="border-radius: 8px; background-color: #21324a; color: white"
          icon="print"
        />

        <q-btn
          @click="confirmarRejeitarMaster"
          label="Rejeitar Master"
          color="negative"
          style="border-radius: 8px; background-color: #21324a; color: white"
          icon="close"
        />
      </div>
    </div>

    <q-table
      flat
      table-header-style="background-color: #d9effc"
      :rows="rows"
      :columns="columns"
      :loading="disable"
      class="tabela-tamanho-fixo"
      :filter="filtrar"
      dense
      hide-pagination
      v-model:pagination="pagination"
      :rows-per-page-options="[0]"
      @request="handleRequest"
    >
      <template #body-cell-status="props">
        <q-td>
          <span
            v-if="
              props.row.status === 'aprovada' || props.row.status === 'aprovado'
            "
            style="text-transform: capitalize"
          >
            {{ props.row.status }} - Por - {{ props.row.aprovador?.nome }}
          </span>
          <span
            v-else-if="
              props.row.status === 'reprovada' ||
              props.row.status === 'reprovado'
            "
            style="text-transform: capitalize"
          >
            {{ props.row.status }} - Por - {{ props.row.aprovador?.nome }}
          </span>
          <span v-else style="text-transform: capitalize">{{
            props.row.status
          }}</span>
        </q-td>
      </template>

      <template #body-cell-comentario="props">
        <q-td>
          <q-input
            dense
            v-model="props.row.comentario"
            outlined
            label="Comentario"
            :disable="aprovacao != 'pendente'"
          />
        </q-td>
      </template>

      <template #body-cell-acao="props">
        <q-td>
          <div class="row">
            <q-btn
              @click="confirmarAprovar(props.row.comentario)"
              class="q-ml-sm"
              color="positive"
              label="Aprovar"
              v-if="
                props.row.status == 'aguardando' && aprovacao == 'aguardando'
              "
            />

            <q-btn
              @click="confirmarRejeitar(props.row.comentario)"
              class="q-ml-sm"
              color="negative"
              label="Rejeitar"
              v-if="
                props.row.status == 'aguardando' && aprovacao == 'aguardando'
              "
            />
          </div>
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-my-md" v-if="rows.length > 0">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
    <DialogConfirmDesign
      :exibir="modalRejeitarMaster"
      mensagem="Tem certeza que deseja rejeitar esse pedido? Todas aprovações deverão ser coletas novamente"
      @resultado="handleRejeitarMasterConfirmacao"
    />
    <DialogConfirmDesign
      :exibir="modalAprovar"
      mensagem="Tem certeza que deseja aprovar este pedido?"
      @resultado="handleAprovarConfirmacao"
    />

    <DialogConfirmDesign
      :exibir="modalRejeitar"
      mensagem="Tem certeza que deseja reprovar este pedido?"
      @resultado="handleRejeitarConfirmacao"
    />
  </div>
</template>

<script>
const columns = [
  {
    name: "etapa",
    label: "Etapa",
    field: "etapa",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "aprovador",
    label: "Aprovador",
    field: "nome",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "comentario",
    label: "Comentário",
    field: "comentario",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "status",
    label: "Status",
    field: "status",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },

  {
    name: "data_decisao",
    label: "Ação tomada em:",
    field: "data_decisao",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },

  {
    name: "acao",
    label: "Ações",
    field: "acao",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { useQuasar } from "quasar";
import DialogConfirmDesign from "../../../../components/DialogConfirmDesign.vue";

export default {
  components: { DialogConfirmDesign },
  props: {
    id: {},
    att: {
      type: Number,
      default: 0,
    },
  },
  setup(props, { emit }) {
    const router = useRouter();
    const store = useStore();
    const $q = useQuasar();
    const rows = ref([]);
    const disable = ref(true);
    const modalRejeitarMaster = ref(false);
    const modalAprovar = ref(false);
    const modalRejeitar = ref(false);
    const comentarioTemp = ref("");

    const route = useRoute();
    const id = route.params.id;
    const status = ref(null);
    const aprovacao = ref(null);

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 25,
      rowsNumber: 15,
    });

    const getDados = async () => {
      try {
        const response = await store.dispatch("compras/pedidoEspecifico", {
          id: id,
        });

        rows.value = response.data.message.aprovacoes;
        status.value = response.data.message.status;
        aprovacao.value = response.data.message.aprovacao;

        disable.value = false;
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro ao encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const confirmarAprovar = (comentario) => {
      comentarioTemp.value = comentario;
      modalAprovar.value = true;
    };

    const handleAprovarConfirmacao = async (confirmado) => {
      modalAprovar.value = false;
      if (confirmado) {
        await aprovar(comentarioTemp.value);
      }
      comentarioTemp.value = "";
    };

    const confirmarRejeitar = (comentario) => {
      comentarioTemp.value = comentario;
      modalRejeitar.value = true;
    };

    const handleRejeitarConfirmacao = async (confirmado) => {
      modalRejeitar.value = false;
      if (confirmado) {
        await negar(comentarioTemp.value);
      }
      comentarioTemp.value = "";
    };

    const confirmarRejeitarMaster = () => {
      modalRejeitarMaster.value = true;
    };

    const handleRejeitarMasterConfirmacao = async (confirmado) => {
      modalRejeitarMaster.value = false;
      if (confirmado) {
        await rejeitarEspecial();
      }
    };

    const aprovar = async (observacao) => {
      try {
        await store.dispatch("compras/aprovarPedido", {
          purchase_id: id,
          observacao: observacao,
        });

        disable.value = false;
        getDados();
        emit("atualizar");

        $q.notify({
          message: "Aprovado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro ao aprovar pedido",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const negar = async (observacao) => {
      try {
        await store.dispatch("compras/negarPedido", {
          purchase_id: id,
          observacao: observacao,
        });

        disable.value = false;
        getDados();
        emit("atualizar");
        $q.notify({
          message: "Negado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro ao negar pedido",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const imprimir = async () => {
      router.push({
        name: "compras-imprimir-pedidos",
        params: { id: props.id },
      });
    };

    const rejeitarEspecial = async () => {
      try {
        await store.dispatch("compras/rejeitarEspecial", {
          purchase_id: id,
        });

        disable.value = false;
        getDados();
        emit("atualizar");
        $q.notify({
          message: "Rejeitado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro ao rejeitar pedido",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => props.att,
      () => {
        disable.value = true;
        handleRequest();
      },
      { deep: true }
    );

    return {
      pagination,
      rows,
      disable,
      columns,
      aprovar,
      getDados,
      handleRequest,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      negar,
      imprimir,
      status,
      aprovacao,
      rejeitarEspecial,
      modalRejeitarMaster,
      confirmarRejeitarMaster,
      handleRejeitarMasterConfirmacao,
      modalAprovar,
      modalRejeitar,
      comentarioTemp,
      confirmarAprovar,
      handleAprovarConfirmacao,
      confirmarRejeitar,
      handleRejeitarConfirmacao,
    };
  },
};
</script>

<style>
.align {
  align-items: center;
}
</style>
